@import '../../../../../constants/spacing.module.less';

.requested-service-container {
  flex-wrap: nowrap;
  align-items: center;
}

.shipping-service-wrapper {
  flex: 1 1 auto;
  min-width: 0;
}

.rate-browser-button-wrapper {
  margin-left: @space-8;
  flex-shrink: 0;
}
